module.exports = __webpack_public_path__ + "src/assets/img/activities_outlet.0d238015.jpg";